export default "__VITE_ASSET__BDn8Gpof__"